<template>
  <element>
    <AppBar :title="$t('cameraPage.title')"></AppBar>
    <v-container>
      <h3 class="category-label">{{ $t('cameraPage.subtitle') }}</h3>
      <CameraDesktop ref="cameraDesktop" />
      <CameraMobile class="d-none" ref="cameraMobile" />
      <v-btn
        class="mt-3"
        color="#033e8c"
        height="45px"
        dark
        depressed
        block
        @click="uploadPictures()"
      >
      {{ $t('cameraPage.button') }}
      </v-btn>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import CameraDesktop from "@/components/camera/CameraDesktop.vue";
import CameraMobile from "@/components/camera/CameraMobile.vue";

export default {
  name: "CameraPage",
  components: {
    AppBar,
    CameraDesktop,
    CameraMobile
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    uploadPictures() {
      this.$refs.cameraDesktop.upload()
    }
  }
}
</script>

<style scoped>

</style>